import { api } from "@/lib/api"
import type { AuthUser } from "./store"

export interface LoginCredentials {
  username: string
  password: string
  otpCode?: string
}

export async function login(credentials: LoginCredentials): Promise<AuthUser> {
  const response = await api.post<AuthUser>("/api/auth/login", credentials)
  return response.data
}

export async function logout(): Promise<void> {
  await api.post("/api/auth/logout")
}

export async function getMe(): Promise<AuthUser> {
  const response = await api.get<AuthUser>("/api/me")
  return response.data
}
